import { ModalFactory } from '@vend/vend.ui'
import serviceModalTemplate from './service-modal.html'
import { STEPS } from './Steps/types'

/**
 * Service class for service order customer modals.
 *
 * @class ServiceModalService
 */
export class ServiceModalService {
  constructor(private readonly Modal: ModalFactory) {
    'ngInject'
  }

  /**
   * Open the modal responsible for adding additional info to service order
   *
   * @method serviceModal
   *
   * @return {ModalInstance} The instance of the modal.
   */
  public serviceModal(startWithStep: STEPS, isEditing: boolean) {
    return this.Modal({
      controller: 'serviceModalController',
      controllerAs: '$ctrl',
      template: serviceModalTemplate,
      startWithStep,
      isEditing,
    })
  }
}
